import React from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";
import { useSearchParams } from "react-router-dom";
import { FilterKeys } from "../../../enums/query-params/filters";
import { RoomMiniOption } from "./RoomSelect";
import RoomData from "../../../interfaces/robot/rooms/room-data";
import Base64Image from "../../../components/misc/Base64Image";

const RoomSelector: React.FC<{ room: RoomData; onClick: () => void }> = ({ room, onClick }) => {
  const [queryParams] = useSearchParams();
  const queryRoomId = queryParams.get(FilterKeys.RoomId);

  const isSelected = queryRoomId === room.id;

  return (
    <React.Fragment>
      <MenuItem
        value={room.id}
        sx={(theme) => ({
          minWidth: "208px",
          p: 2,
          pb: 1,
          pt: room.secondaryStation == null ? undefined : 1,
          boxShadow: isSelected ? "inset 0 0 8px rgba(0,0,0,0.5)" : undefined,
          color: isSelected ? theme.palette.primary.main : undefined
        })}
        onClick={isSelected ? undefined : onClick}
      >
        {room.secondaryStation == null ? (
          <Stack justifyContent="center" width="100%">
            <Box sx={{ height: "120px", width: "100%", backgroundColor: "rgb(205,205,205)", mb: 0.5 }}>
              <Base64Image
                imageString={room.map}
                alt={room.name}
                style={{
                  maxWidth: "100%",
                  maxHeight: "100%",
                  marginLeft: "auto",
                  marginRight: "auto",
                  display: "block",
                }}
              />
            </Box>
            <Typography
              variant="subtitle2"
              whiteSpace="wrap"
              textAlign="center"
              sx={(theme) => ({ lineHeight: theme.spacing(4) })}
            >
              {room.name}
            </Typography>
          </Stack>
        ) : (
          <RoomMiniOption roomMetaInfo={room} />
        )}
      </MenuItem>
    </React.Fragment>
  );
};

export default RoomSelector